








import { Component, Vue } from "vue-property-decorator";

@Component({})
export class AppComponent extends Vue {
  
}

export { AppComponent as default };
